module.exports = __webpack_public_path__ + "img/image-example1.9642acc2.png";